import { useEffect, useMemo, useState } from 'react';
import Breadcrumb from '@/components/base/Breadcrumb';
import NewsCard from '@/components/base/NewsCard';
import EmptyState from '@/components/base/EmptyState';
import { newsList } from '@/mocks/news';
import { usePageMeta } from '@/hooks/usePageMeta';

const PAGE_SIZE = 5;

export default function NewsList() {
  const [activeCategory, setActiveCategory] = useState('全部');
  const [visible, setVisible] = useState(PAGE_SIZE);

  usePageMeta({
    title: '电影资讯 - 草民电影',
    description:
      '草民电影资讯频道，汇总最新票房动态、影片消息与行业观察，带你第一时间了解影坛变化与幕后故事。',
  });

  const categories = useMemo(
    () => ['全部', ...Array.from(new Set(newsList.map((item) => item.category)))],
    [],
  );

  const filtered = useMemo(
    () =>
      activeCategory === '全部'
        ? newsList
        : newsList.filter((item) => item.category === activeCategory),
    [activeCategory],
  );

  useEffect(() => {
    setVisible(PAGE_SIZE);
  }, [activeCategory]);

  const shown = filtered.slice(0, visible);

  return (
    <div className="w-full px-4 py-8 md:px-6 md:py-10">
      <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '电影资讯' }]} />

      <header className="mt-5">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">电影资讯</h1>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-500">
          票房动态、影片消息、幕后揭秘与行业观察，我们持续整理电影世界里的每一次变化。
        </p>
      </header>

      <div className="mt-6 flex flex-wrap gap-2">
        {categories.map((category) => (
          <button
            key={category}
            type="button"
            onClick={() => setActiveCategory(category)}
            className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
              activeCategory === category
                ? 'bg-primary-500 text-background-50'
                : 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200'
            }`}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="mt-6 flex flex-col gap-4">
        {shown.length === 0 ? (
          <EmptyState
            title="暂无资讯"
            message="当前分类下暂时没有内容，建议返回首页浏览其他板块。"
            icon="ri-newspaper-line"
            actionLabel="返回首页"
            onAction={() => window.REACT_APP_NAVIGATE('/')}
          />
        ) : (
          shown.map((item) => <NewsCard key={item.id} item={item} />)
        )}
      </div>

      {visible < filtered.length && (
        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={() => setVisible((prev) => prev + PAGE_SIZE)}
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-add-line" /> 加载更多
          </button>
        </div>
      )}
    </div>
  );
}